export default class DateParser {
  static parse(dateString: string): Date {
    return new Date(Date.parse(dateString));
  }

  static parseNullable(dateString: string): Date | null {
    return dateString ? DateParser.parse(dateString) : null;
  }
}
